import { useEffect, useRef } from 'react';
import { usePlayer as useReactPlayer } from '@landr/react-player';

const useCurrentTimeRef = (id: string | undefined) => {
    const { currentTime } = useReactPlayer(id || null);
    const currentTimeRef = useRef(0);

    useEffect(() => {
        currentTimeRef.current = currentTime ?? 0;
    }, [currentTime]);

    return currentTimeRef;
};

export default useCurrentTimeRef;
